const Playground = () => {
    return <div>Please select the menu on the left to see an example ...</div>
}

export default Playground
